// extracted by mini-css-extract-plugin
export default {"category":"ProductCategoryPage_category__e+JTI","fade-in":"ProductCategoryPage_fade-in__mx0AH","dropdown":"ProductCategoryPage_dropdown__VaByP"};